module.exports = __webpack_public_path__ + "media/img/iryo/infinita-671e72cff323f9ed705513710919692f.svg";